import PermIdentity from '@material-ui/icons/PermIdentity';
// import {
//     ShowGuesser,
//     // EditGuesser
// } from 'react-admin';


import {Groups} from "./Groups";
// import {BaseListIdNameEdit} from "./BaseListIdNameEdit";
// import {BaseListIdNameCreate} from "./BaseListIdNameCreate";

const resource = {
    list: Groups,
    // create: BaseListIdNameCreate,
    // edit: BaseListIdNameEdit,
    // show: ShowGuesser,
    icon: PermIdentity,
};

export default resource;